/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : api.ts
 *
 * Project Title : RDR7000
 *
 * Description   : API Redux Middleware
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Oct 08, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Oct 08, 2020
 * Description   : Add code to define middleware for making API calls
 *
 *
 ******************************************************************************/

// @ts-nocheck
import axios, { AxiosResponse, AxiosError } from 'axios';
import { IAPIPayload, apiCallBegan, apiCallFailed, apiCallSuccess } from './apiTypes';
import { appConfig, forceDownload } from 'shared/utils';
import { setErrorNotification } from 'stores/UIStore';

export const api = ({ dispatch }) => next => async action => {
  if (action.type !== apiCallBegan.type) return next(action);

  dispatch(setErrorNotification(null));

  const {
    url,
    method,
    data,
    params,
    responseType,
    onStart,
    onSuccess,
    onError,
    showGlobalError,
  }: IAPIPayload = action.payload;

  if (onStart) dispatch({ type: onStart });

  next(action);

  try {
    const response: AxiosResponse = await axios.request({
      baseURL: appConfig.api_endpoint,
      url,
      method,
      params,
      responseType,
      data,
    });

    if (url.includes('/configuration/download')) {
      const fileNameHeader = response.headers['content-disposition'];
      forceDownload(response.data, fileNameHeader);

      if (onSuccess) dispatch({ type: onSuccess });
    } else {
      dispatch(apiCallSuccess(response.data));

      if (onSuccess) dispatch({ type: onSuccess, payload: response.data });
    }
  } catch (error) {
    const {
      response,
      request,
    }: {
      response?: AxiosResponse;
      request?: XMLHttpRequest;
    } = error as AxiosError;

    let errorMessage = '';
    let errorDescription = '';

    if (response) {
      if (response.status === 400 && response.data?.status) {
        errorMessage = response.data.status;
        errorDescription = response.data.status;
      } else if (response.status === 502) {
        errorMessage = 'Bad Gateway';
        errorDescription = 'The server returned an invalid or incomplete response.';
      } else if (response.status === 503) {
        errorMessage = 'Application is not available';
        errorDescription =
          'The application is currently not serving requests at this endpoint. It may not have been started or is still starting.';
      } else {
        errorMessage = response.data?.errorMessage;
        errorDescription = response.data?.errorDescription;
      }
    } else if (request) {
      errorMessage = error.message;
      errorDescription = 'Request failed. Please try again.';
    }

    dispatch(apiCallFailed(errorMessage));

    if (onError) {
      dispatch({ type: onError, payload: { errorMessage, errorDescription } });

      if (showGlobalError && errorMessage !== 'Python validation failed') {
        dispatch(setErrorNotification({ errorMessage, errorDescription }));
      }
    } else {
      dispatch(setErrorNotification({ errorMessage, errorDescription }));
    }
  }
};
